<template>
	<div id="app" @click="OperatingWebsite()">
		<router-view></router-view>
	</div>
</template>


<script>
	export default {
		name: 'APP',
		data() {
			return {
				currentTime: new Date().getTime(),
				clear:''
			}
		},
		methods: {
			OperatingWebsite() { /* 30分钟为操作退出登录并跳转到登录 */
				let t=this;
				let timeOut = 30 * 60 * 1000; //设置时间 30分钟
				t.currentTime = new Date().getTime();
				if(t.clear!=''){
					clearTimeout(t.clear);
				}
				t.clear=setTimeout(function(){
					if (new Date().getTime() - t.currentTime > timeOut) {
						// 未操作页面，记录当前时间并跳转登录页面
						t.currentTime = new Date().getTime();
						sessionStorage.removeItem('information');
						t.$router.push({
							path: '/'
						})
					} 
				},timeOut)
			}
		},
	}
</script>
<style lang="less">
	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	body {
		margin: 0;
		outline: 0;
	}

	input,
	div,
	p,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		outline: 0;
		box-sizing: border-box;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	div.popperbutton {
		min-width: 100px;
		text-align: center;
		padding: 0;
		color: #d3423b;
		border-radius: 0;
		border: 0;

		p {
			margin: 10px 0;
			cursor: pointer;
		}
	}

	.border0 {
		input {
			border: 0;
		}
	}

	.border0.color {
		input {
			color: #333 !important;
		}
	}
</style>
